import Cookie from 'js-cookie'

class CookieStorage {
  setItem (key, val) {
    Cookie.set(key, val)
  }
  getItem (key) {
    Cookie.get(key)
  }
  removeItem (key) {
    Cookie.remove(key)
  }
}

class Storage {
  constructor () {
    let storage = window.localStorage
    try {
      storage.setItem('test:key', 'val')
      storage.removeItem('test:key')
    } catch (e) {
      storage = new CookieStorage()
    }
    this.storage = storage
  }

  set (key, val) {
    return this.storage.setItem(key, val)
  }

  get (key) {
    return this.storage.getItem(key)
  }

  remove (key) {
    return this.storage.removeItem(key)
  }
}

export default new Storage()



// WEBPACK FOOTER //
// ./src/storage.js